// Key Address Page Translation
export default {
  // Input placeholders
  placeholders: {
    address: "Enter address",
    blockchain: "Select blockchain",
    canvas: "Select canvas",
  },

  // Buttons
  buttons: {
    reset: "Reset",
    search: "Search",
    edit: "Edit",
    delete: "Delete",
  },

  // Statistics
  statistics: {
    total: "Total",
    totalData: "records",
  },

  // Table column headers
  table: {
    index: "No.",
    address: "Address",
    blockchain: "Blockchain",
    balance: "Balance (USDT)",
    remark: "Remark",
    relatedCanvas: "Related Canvas",
    creator: "Creator",
    createTime: "Create Time",
    action: "Action",
  },

  // Dialogs
  dialogs: {
    title: "Confirm",
    deleteConfirm: "Are you sure you want to delete this address?",
  },

  // Messages
  messages: {
    noData: "No data",
    deleteSuccess: "Deleted successfully!",
    deleteCancelled: "Delete cancelled",
    markSuccess: "Marked successfully!",
    copySuccess: "Copied successfully!",
    loading: "Loading",
  },

  // Confirm buttons
  confirm: {
    ok: "OK",
    cancel: "Cancel",
  },

  // Edit Remark Dialog
  editDialog: {
    title: "Edit Remark",
    label: "Remark",
    placeholder: "Please enter remark (required)",
    validation: {
      required: "Remark is required",
    },
    buttons: {
      reset: "Reset",
      confirm: "Confirm",
    },
    messages: {
      editSuccess: "Modified successfully",
    },
  },
};
